var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.882148C0 0.394985 0.394993 0 0.882149 0H11.4704C11.9578 0 12.3528 0.394993 12.3528 0.882148V11.4703C12.3528 11.9578 11.9578 12.3528 11.4704 12.3528H0.882149C0.394985 12.3528 0 11.9578 0 11.4703V0.882148ZM1.7646 1.7646V10.5884H10.5884V1.7646H1.7646Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.5294C0 18.042 0.394993 17.647 0.882149 17.647H11.4704C11.9578 17.647 12.3528 18.042 12.3528 18.5294V29.1176C12.3528 29.6048 11.9578 29.9998 11.4704 29.9998H0.882149C0.394985 29.9998 0 29.6048 0 29.1176V18.5294ZM1.7646 19.4116V28.2353H10.5884V19.4116H1.7646Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.647 6.17625C17.647 2.76518 20.4122 0 23.8235 0C27.2346 0 29.9998 2.76518 29.9998 6.17625C29.9998 9.58754 27.2346 12.3528 23.8235 12.3528C20.4122 12.3528 17.647 9.58762 17.647 6.17625ZM23.8235 1.7646C21.3868 1.7646 19.4116 3.73983 19.4116 6.17625C19.4116 8.61297 21.3868 10.5882 23.8235 10.5882C26.2599 10.5882 28.2352 8.61297 28.2352 6.17625C28.2352 3.73983 26.2599 1.7646 23.8235 1.7646Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.647 18.5294C17.647 18.042 18.042 17.647 18.5294 17.647H29.1176C29.6048 17.647 29.9998 18.042 29.9998 18.5294V29.1176C29.9998 29.6048 29.6048 29.9998 29.1176 29.9998H18.5294C18.042 29.9998 17.647 29.6048 17.647 29.1176V18.5294ZM19.4116 19.4116V28.2353H28.2353V19.4116H19.4116Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.ef38587af4f0da251a8cc426c585d867.svg";
export { ForwardRef as ReactComponent };